var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 22,
    viewBox: "0 0 14 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3307 1.4123L0.966944 10.4023C0.439404 10.908 0.439404 11.7523 0.966944 12.2601L10.3307 21.248C10.905 21.7994 11.8116 21.7994 12.3858 21.248C12.9933 20.6643 12.9933 19.6924 12.3858 19.1077L4.54342 11.5789C4.40112 11.4428 4.40112 11.2175 4.54342 11.0814L12.3858 3.5526C12.9933 2.969 12.9933 1.997 12.3858 1.4123C12.0982 1.1382 11.7285 1 11.3588 1C10.9881 1 10.6184 1.1382 10.3307 1.4123Z",
    fill: "#FAE6C4",
    stroke: "#152B35",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.fcd249071cb89aad702a26869e1b6685.svg";
export { ForwardRef as ReactComponent };